import Auth from "@aws-amplify/auth"
import devawsconfig from "./dev/aws-exports"
import prodawsconfig from "./prod/aws-exports"

const cfg = process.env.VUE_APP_ENV === 'prod' ? prodawsconfig : devawsconfig

if(process.env.VUE_APP_ENV_AMPLIFY_CLIENT_ID_OVERRIDE) {
  console.log('overwriting amplify client id to local')
  cfg.aws_user_pools_web_client_id = process.env.VUE_APP_ENV_AMPLIFY_CLIENT_ID_OVERRIDE
  cfg.Auth.userPoolWebClientId = process.env.VUE_APP_ENV_AMPLIFY_CLIENT_ID_OVERRIDE
  cfg.Auth.oauth.clientId = process.env.VUE_APP_ENV_AMPLIFY_CLIENT_ID_OVERRIDE
  cfg.Auth.oauth.redirectSignIn = 'http://localhost:8080/login/'
  cfg.Auth.oauth.redirectSignOut = 'http://localhost:8080/login/'
}

if(process.env.VUE_APP_LOCAL === 'true') {
  console.log(`process.env.VUE_APP_LOCAL is ${process.env.VUE_APP_LOCAL}`)
  cfg.Auth.oauth.redirectSignIn = 'http://localhost:8080/login/'
  cfg.Auth.oauth.redirectSignOut = 'http://localhost:8080/login/'
}

Auth.configure(cfg)

export default cfg
